import React from 'react';
import {
  AdminMemberProfileModal,
  ArtistMemberProfileModal,
} from './memberProfileModalVariants';

const MODAL_BY_VARIANT = {
  admin: AdminMemberProfileModal,
  artist: ArtistMemberProfileModal,
};

function resolveTargetProfile(target, payloadKey) {
  if (!target) return null;
  const resolvedKey = typeof payloadKey === 'string' && payloadKey.trim() ? payloadKey.trim() : 'payload';
  const profile =
    target[resolvedKey] ??
    target.payload ??
    target.data ??
    null;
  if (!profile || !target.type) return null;
  return {
    type: target.type,
    artist: target.type === 'artist' ? profile : null,
    admin: target.type === 'admin' ? profile : null,
  };
}

export default function ChatProfileModalLayer({
  profileTarget = null,
  artistProfile = null,
  adminProfile = null,
  payloadKey = 'payload',
  onClose,
  variant = 'admin',
  allowArtistLink,
}) {
  const ModalComponent = MODAL_BY_VARIANT[variant] || AdminMemberProfileModal;
  const profileState =
    resolveTargetProfile(profileTarget, payloadKey) ||
    (artistProfile
      ? { type: 'artist', artist: artistProfile, admin: null }
      : adminProfile
        ? { type: 'admin', artist: null, admin: adminProfile }
        : null);

  if (!profileState) return null;

  return (
    <ModalComponent
      type={profileState.type}
      artist={profileState.artist}
      admin={profileState.admin}
      onClose={onClose}
      allowArtistLink={allowArtistLink}
    />
  );
}
